import React from 'react'

import { IconStyles } from '../types'
import { ContentCopyCustom } from './styles'

interface CopyIconProps extends IconStyles {
  onClick?: any
}

export const CopyIcon: React.FC<CopyIconProps> = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon,
  disabled,
  height,
  width,
}) => {
  return (
    <ContentCopyCustom
      {
        ...{
          colorIcon,
          cursor,
          disabled,
          height,
          marginBottom,
          marginLeft,
          marginRight,
          marginTop,
          width
        }
      }
      onClick={disabled ? null : onClick}
    />
  )
}
